import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { HistoryAndMissionSection } from '../components/HistoryAndMissionSection';
import { OurTeamSection } from '../components/OurTeamSection';

import whoWeAreImg from '@/assets/whoWeAre_illustration.svg';
import { logContactClick } from '@/utils/analytics-utils';
import { scrollToElement } from '@/utils/scroll-to-element';

export const WhoWeAre = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('whoWeAre');

  return (
    <>
      <div className="section">
        <h1 className="section-title flex justify-self-center">{t('title')}</h1>

        <div className="flex justify-center mt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-4/6">
            <div className="col-span-2">
              <div className="section-content">{t('subtitle')}</div>

              <div className="flex justify-center md:justify-start items-center mt-8">
                <button
                  className="action-button"
                  onClick={() => {
                    logContactClick('WhoWeAre_IntroSection', t('writeUs'));
                    scrollToElement('contact-section');
                  }}
                >
                  {t('writeUs')}
                </button>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <img
                src={whoWeAreImg}
                alt={t('title')}
                className="h-[50v] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <HistoryAndMissionSection />
      <OurTeamSection />
    </>
  );
};
